import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import Image from "react-bootstrap/Image";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { TopTextReusableComponent } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingLink,
  ReusableOnboardingButton,
} from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { BackLogoIconButton } from "../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { MobileTopHeader } from "../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import Media from "react-media";
import isEmpty from "../../../../../store/validation/is-Empty";

export const MapSetupScreenTwoWrapper = ({ localProps, state, ...props }) => {
  const editAction = useSelector((state) => {
    return !isEmpty(
      state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData
    )
      ? state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData
      : false;
  });
  return (
    // <Fragment>
    //   <div className="container-fluid">
    //     <div className="row">
    //       <div
    //         id="onboarding-scrollbar"
    //         className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left"
    //       >
    //         {/* <div className="col-12 onboarding_process_screen_left-backbutton">
    //           <NavLink to="/mapsetup" className="back_button-link">
    //             <Image
    //               src={require("../../../../assets/images/Icon/onBoardBack.png")}
    //               alt="Back Button"
    //               title="Back Button"
    //             />
    //           </NavLink>
    //         </div> */}
    //         <Media query="(min-width: 992px)">
    //           <div className="col-12">
    //             <BackLogoIconButton
    //               displayBackText={true}
    //               displayArrow={true}
    //               backButtonClicked="/addvendormapdetails"
    //             />
    //           </div>
    //         </Media>
    //         <Media query="(max-width: 991px)">
    //           <MobileTopHeader link={true} onLink={"/addvendormapdetails"} />
    //         </Media>
    //         <div className="onboarding_process_screen-left-mapinside">
    //           <div>
    //             <TopTextReusableComponent
    //               headingText="Map Setup"
    //               headingParagraph="Business names on Amealio need to be written as they appear on the board outside the restaurant"
    //             />
    //           </div>
    //           <div className="row justify-content-between align-items-center py-4">
    //             <h5 className="f12-400 col-7">
    //               Drop a pin to your address Move the marker as required
    //             </h5>
    //             <div className="pl-0 col-5 d-flex align-items-center justify-content-end">
    //               <div
    //                 className="d-flex align-items-center AutoDetectBtn"
    //                 onClick={localProps.onAutoDetectHandler}
    //               >
    //                 <Image
    //                   src={require("../../../../../assets/images/UserManagement/map-pin-red.svg")}
    //                   fluid
    //                   alt="Auto Detect"
    //                   title="Auto Detect Location"
    //                   className="location-detections-popup-map-search"
    //                 />
    //                 <p className="f12-500 text-red">Auto Detect Location</p>
    //               </div>
    //             </div>
    //           </div>

    //           {props.children}
    //           <div className="onboarding-map-setup-screen-autodetect-button">
    //             {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
    //             <ReusableOnboardingLink
    //               buttonTitle="Back Button"
    //               buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
    //               buttonText="Back"
    //               link="/addvendormapdetails"
    //             />
    //             <ReusableOnboardingButton
    //               buttonTitle="Next Button"
    //               buttonText="Next"
    //               buttonType="button"
    //               onClick={
    //                 state.actionButton === false
    //                   ? localProps.onWhitOutApiCall
    //                   : localProps.onSubmitHandler
    //               }
    //               buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
    //             />
    //             {/* </div> */}
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </Fragment>
    <Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="col-6 pl-5 pr-5">
              <div className="super_admin_add_vendor mb-4">
                <h5 className="main_header_text">
                  {editAction ? "Edit" : "Add"} Vendor
                </h5>
                <h4 className="font_20_m">Step : 1</h4>
                <h4 className="font_20_m c_red mt-2 mb-1">Map Setup</h4>
                <hr className="hr_line" />
              </div>
              <TopTextReusableComponent
                headingText="Map Setup"
                headingParagraph="Business names on Amealio need to be written as they appear on the board outside the restaurant"
              />
              <div className="onboarding-map-setup-screen-inside-map col-12 d-flex p-0 justify-content-between">
                <h5 className="onboarding-map-setup-headingtext mt-4">
                  Drop a pin to your address
                </h5>
                <div className="mt-4 mb-4 d-flex align-items-center">
                  <div
                    className="d-flex align-items-center"
                    onClick={localProps.onAutoDetectHandler}
                  >
                    <Image
                      src={require("../../../../../assets/images/UserManagement/map-pin-red.svg")}
                      fluid
                      alt="Auto Detect"
                      title="Auto Detect"
                      className="location-detections-popup-map-search"
                    />
                    <p
                      className="onboarding-map-setup-paragraphtext f14-500"
                      style={{ color: "#EE3A23" }}
                    >
                      Auto Detect Location
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 p-0">{props.children}</div>
              <div className="onboarding-map-setup-screen-autodetect-button mb-3">
                {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
                <ReusableOnboardingLink
                  buttonTitle="Back Button"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                  buttonText="Back"
                  link={
                    editAction
                      ? "/superadminallvendors"
                      : // "/admin_edit_mapdetails"
                        "/addvendormapdetails"
                  }
                />
                <ReusableOnboardingButton
                  buttonTitle="Next Button"
                  buttonText="Next"
                  buttonType="button"
                  onClick={
                    state.actionButton === false
                      ? localProps.onWhitOutApiCall
                      : localProps.onSubmitHandler
                  }
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                />
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default MapSetupScreenTwoWrapper;
